import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { PhoneCall } from 'legacy/lut/components/shared/PhoneCall'

import { IForm } from 'core-components/classes/models/IForm'
import { stylesTable } from 'core-components/library/list'

import { TPhone } from '../models'

interface IGetPhoneCell {
  contact: DataModel | IForm
  cellAttrs: IObjectAny
  phoneType: TPhone
}
export function getPhoneCell({ cellAttrs, contact, phoneType }: IGetPhoneCell) {
  const phone = contact.get(phoneType) || ''
  const code = contact.get(`${phoneType}_Prefix`) || ''
  const guid = contact.get('HPD_Contact_GUID')
  const partnerId = contact.get('PartnerID')

  if (phone) {
    const phoneValue = `${code}${phone || ''}`
    return (
      <td {...cellAttrs} className={stylesTable.cell}>
        <PhoneCall
          partnerId={partnerId}
          value={phoneValue}
          guid={guid}
          onClick={(e: Event) => {
            e.stopPropagation()
          }}
        />
      </td>
    )
  }

  return undefined
}
